// Configuración de la API
export const API_CONFIG = {
  BASE_URL: 'https://apiwebmodel.modelosmart.com',
  TOKEN: 'MS_2024_SECURE_TOKEN_XYZ789ABC123', // Debe coincidir con el del backend
  ENDPOINTS: {
    CONTACT: '/contact.php',
    TRACK_VISIT: '/track-visit.php',
    GET_STATS: '/get-stats.php'
  }
};

// Función helper para hacer requests seguros
export const secureApiRequest = async (endpoint: string, options: RequestInit = {}) => {
  const url = `${API_CONFIG.BASE_URL}${endpoint}`;
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
    'X-API-Token': API_CONFIG.TOKEN,
  };

  const config: RequestInit = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
    credentials: 'include', // Para enviar cookies si es necesario
  };

  try {
    const response = await fetch(url, config);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API Request Error:', error);
    throw error;
  }
};